import { Card } from '@/components/ui/card';
import { Zap, TrendingDown } from 'lucide-react';
import { costBreakdown } from '@/lib/costing';
import { t } from '@/i18n';
import { cn } from '@/lib/utils';

const TARIFF_STYLES = {
  negative: { bg: 'bg-blue-50',    text: 'text-blue-700',    border: 'border-blue-200',    label: 'tariffNegative' },
  offpeak:  { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', label: 'off' },
  standard: { bg: 'bg-amber-50',   text: 'text-amber-700',   border: 'border-amber-200',   label: 'tariffStandard' },
  peak:     { bg: 'bg-rose-50',    text: 'text-rose-700',    border: 'border-rose-200',    label: 'peak' },
};

export const CrusherTariffBadge = () => {
  const { tariff, costKc, equation } = costBreakdown();
  const style = TARIFF_STYLES[tariff.type] || TARIFF_STYLES.standard;
  const Icon = tariff.type === 'negative' ? TrendingDown : Zap;

  return (
    <Card className={cn('p-3 bg-white/90 backdrop-blur-md border', style.border)} title={equation}>
      <div className="flex items-center gap-2 mb-1">
        <Icon className={cn('h-3.5 w-3.5', style.text)} />
        <span className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          {t('supplyChain.crusherTariffBadge')}
        </span>
      </div>
      <div className="flex items-baseline gap-1.5 mb-1">
        <span className={cn('text-sm font-bold uppercase', style.text)}>{t(`planning.${style.label}`)}</span>
        <span className="text-xs text-muted-foreground tabular-nums">{tariff.rate} CZK/MWh</span>
      </div>
      <div className="border-t border-border/40 pt-1.5 mt-1.5">
        <div className="text-[10px] text-muted-foreground">{t('supplyChain.crusherCostNow')}</div>
        <div className="text-lg font-bold tabular-nums">{costKc} <span className="text-xs font-normal text-muted-foreground">CZK/t</span></div>
      </div>
    </Card>
  );
};
